export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_6-5e122ce0e8dae1e3688d009f245237ee.jpg";